import dayjs from "@/utils/dayjs";

// Checks whether an age is below a certain year.
export const isBelowAge = (date, yo) => dayjs().diff(dayjs(date, "YYYY-MM-DD"), "years") < yo;

// const date = new Date();
// const currentMonth = date.getMonth();
// const currentSeason = currentMonth < 10 ? date.getFullYear() : date.getFullYear() + 1;
// Registrations Helper - Check for if minor
// eslint-disable-next-line default-param-last
export const isMinorConsistent = (dob, format = "YYYY-MM-DD", endOfSeason) => {
  if (endOfSeason === null || endOfSeason === undefined) {
    const date = new Date();
    const currentSeason = date.getMonth() <= 10 ? date.getFullYear() : date.getFullYear() + 1;
    endOfSeason = `${currentSeason}-12-01`;
  }
  const startOfYearBirth = dayjs(dob, format).startOf("year");
  return dayjs(endOfSeason, "YYYY-MM-DD").diff(startOfYearBirth, "years") <= 18;
};

// Helper - Calcualte Age
// eslint-disable-next-line default-param-last
export const calculateAge = (dob, format = "YYYY-MM-DD", endOfSeason) => {
  if (endOfSeason === null || endOfSeason === undefined) {
    const date = new Date();
    const currentSeason = date.getMonth() <= 10 ? date.getFullYear() : date.getFullYear() + 1;
    endOfSeason = `${currentSeason}-12-01`;
  }

  const startOfYearBirth = dayjs(dob, format).startOf("year");
  return dayjs(endOfSeason, "YYYY-MM-DD").diff(startOfYearBirth, "years");
};
